import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ProgressNavSmall from '~/Common-Objects/Navigation/ProgressNavSmall'
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx'
import i18n from '~/i18n'
import EmailValidator from '~/Classes/emailValidator'
import axios from '~/data/http/axios'
import DomainServicePicker from './domainServicePicker/domainServicePicker'
import SetupInstructions from './setupInstructions/setupInstructions'
import VeryifySetup from './verifySetup/verifySetup'
import { parse } from 'tldts'

export default function FlowTemplate({
    domainProviders = [],
    domain = {},
    currentStep = 'domainServicePicker',
    setFlowStep = () => {},
    domainRecords = [],
    setDomainRecords = () => {},
    updateDomain = () => {},
    domainProvider = null,
    setDomainProvider = () => {},
    finish = () => {},
    getDomain = () => {}
}) {
    let instructionsStep = false
    if (
        currentStep == 'dnsInstructions' ||
        currentStep == 'spfDkimSettings' ||
        currentStep == 'dmarcSettings' ||
        currentStep == 'trackingSettings' ||
        currentStep == 'cdnSettings'
    ) {
        instructionsStep = true
    }

    if (instructionsStep && !domain.serviceProvider) {
        instructionsStep = false
        currentStep = 'domainServicePicker'
    }

    let stepNavNo = 1
    if (currentStep == 'domainServicePicker') stepNavNo = 1
    if (instructionsStep) stepNavNo = 2
    if (currentStep == 'verifySetup') stepNavNo = 3

    const subDomain = parse(domain.domainName)?.subdomain

    return (
        <div>
            <ProgressNavSmall steps={3} step={stepNavNo} className='mar-b36' />
            <div style={{ display: 'flex', justifyContent: 'center' }} className='mar-b16'>
                <SquareChip value={domain.domainName} />
            </div>
            {currentStep == 'domainServicePicker' && (
                <DomainServicePicker
                    domainId={domain.id}
                    setFlowStep={setFlowStep}
                    domainProvider={domainProvider}
                    setDomainProvider={setDomainProvider}
                    domainProviders={domainProviders}
                    updateDomain={updateDomain}
                />
            )}
            {instructionsStep && (
                <SetupInstructions
                    finish={finish}
                    subDomain={subDomain}
                    setFlowStep={setFlowStep}
                    currentStep={currentStep}
                    domainProvider={domainProvider}
                    domain={domain}
                    domainRecords={domainRecords}
                    setDomainRecords={setDomainRecords}
                    updateDomain={updateDomain}
                />
            )}
            {currentStep == 'verifySetup' && (
                <VeryifySetup
                    getDomain={getDomain}
                    finish={finish}
                    domain={domain}
                    setFlowStep={setFlowStep}
                    domainProvider={domainProvider}
                    domainRecords={domainRecords}
                    setDomainRecords={setDomainRecords}
                />
            )}
        </div>
    )
}
